// src/components/shell/AccountMenu.jsx
import React, { useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { UserContext } from '../../context/UserContext';
import ActionMenu from '../common/ActionMenu';
import { SignOutIcon, StorageIcon, UserIcon } from './icons';

function Avatar({ user, large = false }) {
    const cls = `qd-avatar${large ? ' qd-avatar--lg' : ''}`;
    if (user?.photoURL) {
        return <span className={cls}><img src={user.photoURL} alt="" /></span>;
    }
    const source = user?.displayName || user?.email || '';
    return <span className={cls} aria-hidden="true">{source.charAt(0).toUpperCase() || 'U'}</span>;
}

/**
 * Who you're signed in as, and the account-level destinations. The storage
 * dashboard is listed here because nothing in the app linked to it before —
 * it was reachable only by typing its URL.
 */
export default function AccountMenu() {
    const { user, logout } = useContext(UserContext);
    const navigate = useNavigate();
    const name = user?.displayName || user?.email || 'Your account';

    return (
        <ActionMenu
            className="qd-account"
            label="Account"
            triggerClassName="qd-avatar-btn"
            triggerAriaLabel="Account menu"
            trigger={<Avatar user={user} />}
            header={(
                <div className="qd-account__id">
                    <Avatar user={user} large />
                    <span className="qd-account__text">
                        <span className="qd-account__name">{name}</span>
                        {user?.email && user.email !== name && (
                            <span className="qd-account__email">{user.email}</span>
                        )}
                    </span>
                </div>
            )}
            items={[
                {
                    id: 'account-settings',
                    label: 'Account settings',
                    icon: <UserIcon />,
                    onSelect: () => navigate('/settings#account-general'),
                },
                {
                    id: 'storage',
                    label: 'Storage & usage',
                    icon: <StorageIcon />,
                    onSelect: () => navigate('/workspace/storage'),
                },
                {
                    id: 'sign-out',
                    label: 'Sign out',
                    icon: <SignOutIcon />,
                    separatorBefore: true,
                    onSelect: logout,
                },
            ]}
        />
    );
}
